import { render, staticRenderFns } from "./LocationIntro.vue?vue&type=template&id=272a5ce8&scoped=true"
import script from "./LocationIntro.vue?vue&type=script&lang=js"
export * from "./LocationIntro.vue?vue&type=script&lang=js"
import style0 from "./LocationIntro.vue?vue&type=style&index=0&id=272a5ce8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272a5ce8",
  null
  
)

export default component.exports